// FeedbackText.tsx
type FeedbackTextProps = {
  message: string;
};

export const FeedbackText = ({ message }: FeedbackTextProps) => (
  <p style={{ color: 'red', marginTop: '0.5rem' }}>{message}</p>
);
